import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';


@Component({
  selector: 'my-modelgroup-dropdown',
  templateUrl: './ModelGroupDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => ModelGroupDropdownComponent)}]
})
export class ModelGroupDropdownComponent extends BaseDropdownComponent {

    public modelGroups: ent.ModelGroup[]= [];
    public filter: filters.ModelGroupFilter;

    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
        this.filter = new filters.ModelGroupFilter();
    }


    ngOnInit(): void {
    }

    public load(){
        //this.domainDataService.getModelGroups(this.filter).subscribe(x=> this.onGetModelGroupsDone(x));
    }

    public loadOnDemand(){

        this.domainDataService.getModelGroups(this.filter).subscribe(x=> this.onGetModelGroupsDone(x));
        
    }
    
    onGetModelGroupsDone(items: ent.ModelGroup[]){
        
        this.selectItems = [];
        this.modelGroups = [];
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}))
        items.forEach(y=> this.modelGroups.push(y));
        if (this.selectedID){
            this.value = this.selectedID;
        }
        
    }

}